import * as fromViewCacheReducers from './view-cache.reducers';

import { ActionReducerMap } from '@ngrx/store';
import { PermissionsViewCacheStates } from '../states';

export const permissionsViewCacheReducers: ActionReducerMap<PermissionsViewCacheStates> = {
  permissionViewCache: fromViewCacheReducers.permissions_view_cache_reducer
};
